<template>
  <b-card header-bg-variant="warning" border-variant="warning">
    <template v-slot:header>
      This is an alpha version of
      <img src="/logo_psos_light_bg.svg" style="height: 1.5rem;" />
    </template>
    <b-card-text>
      It may and probably will contain bugs of different types. Computations may
      break, visualization may not work as expected, the result you expect may
      not be included. If you encounter bugs or want to suggest new analyses,
      profiles, visualizations or changes, please send us an email to
      <a href="mailto:psos@computational.bio">psos@computational.bio</a>.
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "alphanote"
};
</script>
